module.exports = __webpack_public_path__ + "img/payokqr.3cd22686.png";